export const environment = {
  production: true,
  brazil: true,
  apiUrl: 'https://kws-dev-br.ensoft.dev/api',
  assetsUrl: 'https://kws-dev-br.ensoft.dev/assets/photos',
  language: 'pt'
};
